module.exports = __webpack_public_path__ + "static/parade-2019-house02-ff0c94074bcb2be26ca8536d41819282.jpg";